<template>
    <div id="top" :class="{'block-invert block-img': content.settings[0].homeimagealign == 'imgbg', 'mh-100': content.settings[0].herofullheight != true, 'imgrightfullcontainer' : content.settings[0].homeimagealign == 'imgrightfull'}" :style="[content.settings[0].homeimagealign == 'imgbg' ? {'background-image': 'url(' + homeimage + ')'} : {}]" >
        <div id="someid" v-if="content.settings[0].homeimagealign == 'imgrightfull'" class="block-half-img" :style="'background-image: url(' + homeimage + ')'"></div>
        <div class="section-block fullheight center-items" :class="'text-'+content.settings[0].heroalign">
            <div class="container" :class="{'withimgright': content.settings[0].homeimagealign == 'imgright'}">
                
                <div id="hero_unit">
                    <div>
                        <h1 class="display-3 mb-3 mt-5">
                            <div class="resize-font edited_content" style="--resize-xs: 2.3rem;" id="hero-title">
                                <span v-if="readonly" class="edited_content">
                                    {{ content.tagline }} 
                                </span>
                                <inline-editor @clicked="getModeStyle" v-if="!readonly" :editable="content.tagline" dbentry="tagline" element="textarea"/>
                            </div>
                        </h1>
                        <p class="mb-5 display-6">
                            <span v-if="readonly" v-html="content.description">
                            </span>
                            <inline-editor v-if="!readonly" :editable="content.description" dbentry="description" element="textarea"/>
                        </p>
                        <a v-if="content.settings[0].ctalink" :href="content.settings[0].ctalink" class="btn btn-lg btn-primary btn-break">{{content.settings[0].ctatext}}</a>

                        <social-icons v-if="content.settings[0].sociallocation == 'onhome'" :sitesettings="content.settings[0]" class="social-links-big mb-0 mt-5"/>
                    </div>

                    <div class="blocksettingsbuttons" v-if="!readonly" >
                        <button v-if="!readonly" class="btn btn-secondary btn-ico" @click.prevent="imageModal = true, getimages()" ><span class="ico material-icons" style="position: relative; top: -2px; left: -4px;">photo_camera</span></button>
                    </div>

                    <img v-if="content.settings[0].homeimagealign == 'imgunder'" :src="homeimage"  alt="image" class="mw-100 mt-5 shadowed" />
                </div>
                <img v-if="content.settings[0].homeimagealign == 'imgright'" :src="homeimage" alt="image" class="block-feature block-feature-margin shadowed" style="--block-float: right; --block-width: 40%;" />

                <modal v-if="imageModal" @close="imageModal = false" title="Add image">
                    <ul class="imageselector">
                        <li>
                            <upload-modal @clicked="getimages()" :websiteid="websiteid" thestyle="imageuploadbutton btn btn-primary"><span class="material-icons ico">add_circle</span> Upload</upload-modal>
                        </li>
                        <li v-for="image in images">
                            <button class="imagethumb" @click.prevent="setblockimage(image.image)" :style="'background-image: url('+ imageroot + image.image.split('uploads/').pop() +')'">
                                <span>{{ image.image }}</span>
                            </button>
                        </li>
                    </ul>
                    <form v-if="!readonly" id="blockimage" @submit.prevent="changeSiteSetting('mainblockimage', homeimage), changeSiteSetting('settings', content.settings)">
                        <input hidden placeholder="Voer afbeelding in" class="textinput form-control mr-2" type="text" name="field_blockimage" v-model="homeimage">
                        <div class="flex-row">
                            <select v-model="content.settings[0].homeimagealign" class="form-control mr-2">
                                <option value="imgbg" >Afbeelding als achtergrond</option>
                                <option value="imgunder" >Afbeelding onder tekst</option>
                                <option value="imgfull" >Afbeelding over volledige breedte</option>
                                <option value="imgright" >Afbeelding uitgelijnd rechts</option>
                                <option value="imgrightfull" >Afbeelding over de rechterhelft</option>
                                <option value="imgempty" >Geen achtergrondafbeelding</option>
                            </select>
                            <button type="submit" class="btn btn-primary">Opslaan</button>
                        </div>
                    </form>
                </modal>
            </div>
        </div>
            
        <img v-if="content.settings[0].homeimagealign == 'imgfull'" :src="homeimage" alt="image" class="w-100"/>
        <img v-if="content.settings[0].homeimagealign == 'imgrightfull'" :src="homeimage"  alt="image" class="w-100 imgrightfullmob"/>
    </div>
</template>

<script>
import InlineEditor from '../app/InlineEditor.vue';
import Modal from '../modal/Modal.vue';
import UploadModal from '../modal/UploadModal.vue';
import SocialIcons from '../navigation/SocialIcons.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    components:{
        InlineEditor,
        Modal,
        UploadModal,
        SocialIcons
    },
    props:{
      content: {
        type: Object
      },
      homeimage: {
          type: String
      },
      websiteid: {
          type: String
      },
      readonly: {
        type: Boolean
      },
      tutorialStepCount: {
          type: Number
      }
    },
    data: function() {
        return{
            thisobject: this.content,
            imageModal: false,
            file: '',
            images: [],
            imageroot: process.env.VUE_APP_ROOT_API + '/'
        }
    },
    methods: {
        getModeStyle(modeStyle){
            if(modeStyle == 'editing'){
                this.$emit('clicked', 2)
            }

            if(modeStyle == 'edited'){
                this.$emit('clicked', 3)
            }
        },
        setblockimage(image){
            this.homeimage = this.imageroot+image.split("uploads/").pop()
        },
        getimages(){

            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/media/'+this.websiteid, requestOptions)
            .then(response => {
                this.images = response.data.response
            })
        },
        changeSiteSetting(thedbentry, thecontent){

            const requestOptions = {
              headers: authHeader()
            }

            const data = {
                websiteid: this.websiteid,
                dbentry: thedbentry,
                content: thecontent
            }

            axios.patch(process.env.VUE_APP_ROOT_API+'/settings/', data, requestOptions)
            .then(response => {
                if(thedbentry == 'blockalign'){
                    this.blockalign = thecontent
                } 
                if (thedbentry == 'blockheight') {
                    this.blockheight = thecontent
                }
                if (thedbentry == 'blockfontsize') {
                    this.blockfontsize = thecontent
                }
                if (thedbentry == 'mainblockimage') {
                    this.imageModal = false
                }
            })
        }
    }
}
</script>